<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div v-if="closable" class="modal-close text-xs-right">
            <v-btn
              color="grey"
              large
              flat
              icon
              @click="$emit('close')">
              <v-icon large>highlight_off</v-icon>
            </v-btn>
          </div>
          <div v-if="title" class="modal-header">
            <h3 class="header">{{title}}</h3>
          </div>
          <div class="modal-body">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    closable: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';
@import '../../styles/vars/typography';

.modal {
  &-body {
    max-height: 450px;
  }

  &-close {
    position: absolute;
    right: 18px;
    top: 8px;
  }

  &-container {
    background-color: $theme-color-white;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    font-family: $typography-font-primary;
    max-width: 600px;
    margin: 0 auto;
    padding: 20px 30px;
    position: relative;
    transition: all .3s ease;
  }

  &-mask {
    background-color: rgba($theme-color-black, 0.5);
    display: table;
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    transition: opacity .3s ease;
    width: 100%;
    z-index: 9998;
  }

  &-wrapper {
    display: table-cell;
    vertical-align: middle;
  }
}

.header {
  border-bottom: solid 3px $theme-color-primary;
  margin-bottom: 30px;
  padding-bottom: 20px;
  padding-right: 50px;
}
</style>
